import React from "react";

const ModulesContext = React.createContext();

export const ModulesProvider = ModulesContext.Provider;
export const ModulesConsumer = ModulesContext.Consumer;

export default ModulesContext;
